// extracted by mini-css-extract-plugin
module.exports = {"tableDesign":"style-module--tableDesign--37vlr"};